<template>
  <div class="thankyou__container">
    <p>
      <strong>
        Dziękujemy za kontakt z nami i wypełnienie formularza Bezpłatnej
        Konsultacji.
      </strong>
    </p>
    <p>
      W ciągu 1 dnia nasz ekspert skontaktuje się z Tobą, aby podczas krótkiej
      niezobowiązującej konsultacji omówić aktualne wyzwania Twojej organizacji.
    </p>
    <p>
      Od 16 lat pomagamy naszym Klientom skutecznie podnosić efektywność
      procesów i zaangażowanie zespołów. Wypracowaliśmy własne podejście i
      stworzyliśmy Strategię Lean.
      <br /><br />
      Z Leanpassion doskonalenie jest procesem ciągłym, nawet w warunkach
      kryzysu gospodarczego i pracy zdalnej. Klienci doceniają nas za wymierne
      rezultaty w czterech perspektywach strategicznych: wzrost biznesu,
      zwinność, satysfakcja i zaangażowanie, wzrost zysku.
    </p>
    <p>
      <strong>Dziękujemy za okazane nam zaufanie.</strong>
      Wierzymy, że podczas konsultacji uzyskasz odpowiedzi na nurtujące Cię
      wyzwania.
    </p>
  </div>

  <div class="thankyou__recommendations">
    <h4>
      Jeśli masz ochotę na chwilę inspiracji, posłuchaj podcastu Radka
      Drzewieckiego i/lub przeczytaj artykuł na naszym blogu.
    </h4>
    <a
      href="https://leanpassion.pl/skutecznyceo/"
      class="thankyou__recommendations-item"
      target="_blank"
    >
      <span>Słuchaj podcastu Skuteczny CEO</span>
      <img :src="require('@/assets/podcast-bg.png')" alt="Podcast" />
    </a>
    <a
      href="https://leanpassion.pl/blog/"
      class="thankyou__recommendations-item"
      target="_blank"
    >
      <span>Przejdź na bloga</span>
      <img :src="require('@/assets/icons-blog.png')" alt="Blog" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'Thankyou',

  mounted() {
    // this.$router.push('/')
  },
}
</script>

<style lang="scss">
.thankyou {
  &__container {
    border: 0;
    padding: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: var(--color);
    color: var(--color-bg);
    border-radius: var(--border-radius-xl);
    max-width: 60%;
    align-items: flex-start;

    @media screen and (max-width: 1080px) {
      margin: 1rem 0rem;
      padding: 2rem;
      max-width: 100%;
    }

    p {
      margin: 0.75rem 0;
      line-height: 1.75;
      font-size: 1rem;

      &:first-child {
        font-size: 1.5rem;
        margin: 0.75rem 0 1.5rem;
        color: var(--color-action);
        line-height: 1.5;
        padding-right: 2rem;

        @media screen and (max-width: 1080px) {
          padding: 0;
          line-height: 1.25;
        }
      }

      &:last-child {
        font-weight: 500;
        margin-top: 2rem;

        strong {
          font-size: 1.125rem;
          display: block;
        }
      }
    }
  }

  &__recommendations {
    flex: 1;
    padding-left: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 1080px) {
      padding: 1rem 0 0;
    }

    h4 {
      margin: 0 0 2rem;
    }

    &-item {
      text-decoration: none;

      & + & {
        margin-top: 1rem;
      }

      span {
        display: block;
        text-transform: uppercase;
        color: var(--color-action);
        font-size: 0.875rem;
        font-weight: 500;
        margin-bottom: 0.75rem;
      }

      img {
        display: block;
        max-width: 100%;
        filter: drop-shadow(3px 4px 10px rgba(0, 0, 0, 0.5));
      }
    }
  }
}
</style>
